export default __webpack_public_path__ + "static/media/Customer.b6d4eef4.png";